import { FC } from 'react';

import { DataButton, WebpImage } from 'components/Shared/SharedComponents';
import { CombinedFiltersInterface } from 'components/Sections/PsychicsSetMediumSizeImagesClone/declarations';

import styles from '../PsychicFilter.module.scss';

const CombinedFiltersButton: FC<CombinedFiltersInterface> = ({
  filterByTitleRef,
  activeFiltersCounter,
  toggleFilters,
  combinedImage,
}) => {
  const shouldShowCounter = activeFiltersCounter.afterApply > 0;

  return (
    <DataButton
      className={styles.filterBy}
      ref={filterByTitleRef}
      onClick={toggleFilters}
    >
      {combinedImage?.url && (
        <WebpImage
          image="external"
          src={combinedImage?.url}
          className={styles.icon}
        />
      )}
      {shouldShowCounter && (
        <span className={styles.counter}>
          {activeFiltersCounter.afterApply}
        </span>
      )}
    </DataButton>
  );
};

export default CombinedFiltersButton;
